import type { IMoney } from "@jti/magento";
import { FormattedPrice, useTranslations } from "@jti/ui";

import { useCartPrices } from "@checkout-v2/shared/hooks/useCartPrices";

import styles from "./SubscriptionPrices.module.scss";

const PriceEntry = ({ price, description }: { price: IMoney; description: string }) => (
  <div className={styles.priceBoxWrapper}>
    <p className={styles.priceDescription}>{description}</p>
    <FormattedPrice className={styles.priceValue} value={price.value} currency={price.currency} />
  </div>
);

export const SubscriptionPrices = () => {
  const { __ } = useTranslations();

  const { data: cartPricesResponse } = useCartPrices();

  const shippingPrice = cartPricesResponse?.shipping;
  const subscriptionAmount = cartPricesResponse?.subscriptionAmount;

  const isPricesSectionVisible = !!subscriptionAmount || !!shippingPrice;

  return (
    <>
      {isPricesSectionVisible && (
        <div className={styles.pricesSectionContainer}>
          {!!subscriptionAmount && (
            <PriceEntry description={__("summarySubscription.monthlyBilling")} price={subscriptionAmount} />
          )}
          {!!shippingPrice && <PriceEntry description={__("summarySubscription.shipping")} price={shippingPrice} />}
        </div>
      )}
    </>
  );
};
